import { privateClient } from "../../configs/axiosConfig";

const orderEndpoints = {
  createOrder: "v1/orders",
  getUserOrders: "v1/orders",
  getOrderById: (id) => `v1/orders/${id}`,

  stripeCheckout: "v1/orders/checkout", // ✅ add this

  // stripeCheckout: "v1/stripe/checkout", // ✅ add this

  update: "v1/orders/:id",
};

const orderApi = {
  createOrder: async (data) => {
    try {
      const response = await privateClient.post(
        orderEndpoints.createOrder,
        data,
      );
      return { response };
    } catch (err) {
      console.error("Create order error:", err.response?.data || err.message);
      return { err: err.response?.data || { message: err.message } };
    }
  },

  getUserOrders: async () => {
    try {
      const response = await privateClient.get(orderEndpoints.getUserOrders);
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  getOrderById: async (id) => {
    try {
      const response = await privateClient.get(orderEndpoints.getOrderById(id));
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  updateOrderStatus: async ({ id, orderStatus }) => {
    try {
      const response = await privateClient.patch(`v1/orders/${id}/status`, {
        orderStatus,
      });
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  // // stripe checkout
  stripeCheckout: async (data) => {
    try {
      const response = await privateClient.post(
        orderEndpoints.stripeCheckout,
        data,
      );
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
};

export default orderApi;
